import React from 'react';
import { Item } from '../../../../../containers/commerce';
import { Row, Col, Container } from '../../../../grid';
import RowProductView from '../../../../grid/RowProductView';
import { Heading3, Spacer } from '../../../../typography';
import { RelatedView1 } from '../../../Item';

const RenderRelated = ({
  related,
  headline = 'Alternativer til ',
  name,
}) => {
  if (related) {
    return (
      <React.Fragment>
        <Spacer size="20px" />
        <Container white marginBottom="6px">
          <Row>
            <Col xs={12}>
              <Heading3 marginBottom="0">{headline} {name}</Heading3>
            </Col>
          </Row>
        </Container>
        <Container>
          <RowProductView>
            {related.map(
              varenr => (
                <Item
                  varenr={varenr}
                  display={RelatedView1}
                />
              ),
            )}
          </RowProductView>
        </Container>
      </React.Fragment>
    );
  }
  return (null);
};

// Export
export default RenderRelated;
